import React, {useState, useEffect, useRef} from "react";
import socket from "../utils/clientSocket";
import "../App.css";
import {useUser} from "../UserContext";
import UserLink from "./UserLink";

const Chat = ({style, chatType, chatId}) => {
    const [messages, setMessages] = useState([]);
    const [chatInput, setChatInput] = useState("");
    const bottomAnchor = useRef(null)
    const user = useUser()

    useEffect(() => {
        socket.on('chatMessage', (msg) => {
            //while we ensure in the backend that we only send messages to a socket if a socket belongs to that chat,
            //a socket usually belongs to several chats (global, club chat, game chat etc.). Ensure we filter messages
            //such that only the messages belonging to the current chat is shown. Otherwise it causes confusion
            if (msg.chatId !== chatId) {
                return;
            }

            setMessages(prevState => [...prevState, msg]);
        });

        socket.emit("getChatHistory", chatId);

        return () => socket.off('chatMessage');
    }, [chatId]);

    useEffect(() => {
        bottomAnchor.current?.scrollIntoView({block: "nearest"})
    }, [messages])

    useEffect(() => {
        socket.on("chatHistory", (chatHistory) => {
            setMessages(chatHistory)
        })
        return () => socket.off("chatHistory")
    }, [])

    const sendMessage = () => {
        if (!chatInput.trim()) return;

        const newMsg = {text: chatInput.trim(), chatType, chatId, timeSent: Date.now()};
        socket.emit('chatMessage', newMsg);

        //We append our frontend user object afterwards, as there is no reason to send it to the server (which does a lookup anyways)
        newMsg.user = user;
        setMessages(prevState => [...prevState, newMsg]);
        setChatInput("");
    };

    return (
        <div
            className="chat-container"
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: "100%",
                ...style,
                fontSize: "0.8rem"
            }}
        >
            <div
                className="messages"
                style={{flex: 1, overflowY: 'auto', marginBottom: '0.5rem'}}
            >
                {messages.map((msg, idx) => (
                    <div key={idx} className="message"
                         style={{fontSize: "0.75rem", fontFamily: "sans-serif", color: "#555"}}>
                        <p style={{
                            margin: "0",
                            color: "#666",
                            fontSize: "0.5rem"
                        }}>{new Date(msg.timeSent).toLocaleTimeString('en-GB')}</p>
                        <div style={{display: "flex", flexWrap: "wrap"}}>
                            <div style={{display: "flex"}}>
                                <UserLink user={msg.user} style={{
                                    fontWeight: "700",
                                    marginTop: "0",
                                    marginBottom: "0.1rem",
                                    whiteSpace: "nowrap"
                                }}/>
                                <p style={{marginTop: "0", marginBottom: "0", marginRight: "0.2rem"}}>:</p>
                            </div>

                            <p style={{marginBottom: "0", marginTop: "0"}}>{msg.text}</p>
                        </div>
                    </div>
                    ))}
                <div ref={bottomAnchor}/>
            </div>
            <div className="input-container" style={{marginTop: 'auto', display: 'flex'}}>
                <input
                    type="text"
                    value={chatInput}
                    onChange={(e) => setChatInput(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') sendMessage();
                    }}
                    placeholder="Type a message..."
                    className="chat-input"
                    style={{flex: 1, fontSize: "inherit"}}
                />
                <button
                    onClick={sendMessage}
                    className="send-button"
                    style={{fontSize: "inherit"}}
                >
                    Send
                </button>
            </div>
        </div>
    );
};

export default Chat;


